"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.Root = exports.Content = exports.Buttons = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  height: '100%',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-between'
  }
}));
const Content = exports.Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  overflowY: 'auto',
  padding: theme.spacing(0, 3),
  maxHeight: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 4)
  }
}));
const Buttons = exports.Buttons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginTop: theme.spacing(3),
  padding: theme.spacing(0, 3, 6),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(4),
    padding: theme.spacing(0, 4, 6)
  },
  '&:empty': {
    display: 'none'
  }
}));
const Separator = exports.Separator = (0, _mui.styled)('hr')(({
  theme
}) => ({
  border: 0,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  margin: theme.spacing(1, 0)
}));
